import { DataService } from './../../../../../services/data.service';
import { FormControl } from '@angular/forms';
import { Enrollment } from './../../../../../interfaces/course';
import { State } from 'src/app/interfaces/enums';
import { UserType, Student } from 'src/app/interfaces/user';
import { User, Teacher, Kid } from './../../../../../interfaces/user';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Lesson } from 'src/app/interfaces/course';
import * as _ from 'lodash';
import swal from 'sweetalert2';

@Component({
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  private _enrollments: Enrollment[];
  enrollments: any;

  activeEnrollmentGroup: string;

  enrollmentGroupForm = new FormControl();

  user: User | Student | Teacher;
  lessons: Lesson[];
  UserType = UserType;
  State = State;

  isRequestLoading = false;

  constructor(
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private data: DataService
  ) { }

  ngOnInit() {
    this.enrollmentGroupForm.valueChanges.subscribe((v) => {
      this.enrollments = this.groupEnrollmentsBy(v.toLowerCase());
    })

    this.route.params.subscribe((p) => {
      if(p.userid){
        this.getData(p.userid);
      }
    })
  }

  getData(userid){
    this.data.getUser(userid).subscribe((res) => {
      if(res && res.data){
        this.user = res.data;

        switch(this.user.type){
          case UserType.Teacher: {
            this.getEnrollmentsData();
            this.getLessonsData();
            break;
          }
          case UserType.Student: {
            this.getEnrollmentsData();
            break;
          }
          default: {
            this.lessons = [];
            console.log('Unknown type');
          }
        }
      }
    })
  }

  async getLessonsData(){
    this.data.getLessons(undefined, {
      teacher_id: this.user._id,
      students_enrolled: true
    }).subscribe((res) => {
      if(res && res.data){
        this.lessons = res.data;
      }
    })
  }

  async getEnrollmentsData(){
    const user = this.user;

    switch(user.type){
      case UserType.Student: {
        this.data.getEnrollments({
          student_family: user._id
        }).subscribe((res) => {
          if(res && res.data){
            this._enrollments = res.data;
            this.enrollmentGroupForm.setValue('course');
          }
        })

        break;
      }
      case UserType.Teacher: {
        this.data.getEnrollments({
          teacher: user._id
        }).subscribe((res) => {
          if(res && res.data){
            this._enrollments = res.data as Enrollment[];
            this.enrollmentGroupForm.setValue('course');
          }
        })
        break;
      }
    }
  }

  groupEnrollmentsBy(field: string){
    return _.map(_.groupBy(this._enrollments, (v) => v[field]), (v: any, k) => {
      let group;

      if(field === 'student_family'){
        group = `Student family: ${v[0].student_family_name}`;
      }

      if(field === 'course'){
        group = `Course: ${v[0].course_name}`;
      }

      if(field === 'session'){
        group = `Session: ${v[0].session_auto_id}`;
      }

      if(field === 'teacher'){
        group = `Teacher: ${v[0].teacher_name}`;
      }

      return {
        group: group,
        value: v
      }
    });
  }

  async approveTeacher(){
    await this.data.approveTeacher(this.user._id).toPromise();

    this.getData(this.user._id);
  }

  async delete(){
    try{
      const hasEnrollments = _.filter(this._enrollments, v => v.state === State.Active);

      if(hasEnrollments.length){
        throw Error('User still has active enrollments');
      }

      if(this.user.type === UserType.Teacher){
        if(this.lessons && this.lessons.length){
          throw Error('Teacher still has lessons.');
        }
      }

      await this.data.deleteUser(this.user._id).subscribe(() => {
        this.router.navigate(['/admin/users'])
      })

    }catch(e){
      console.error(e);
      this.toastr.error(e.message);
    }
  }

  async requestZoomId(){
    this.isRequestLoading = true;

    this.data.requestZoomId({userid: this.user._id}).subscribe((res) => {
      this.isRequestLoading = false;

      if(res){
        this.getData(this.user._id);
      }
    })
  }

  async deleteZoomId(){
    this.isRequestLoading = true;

    this.data.deleteZoomId(this.user._id).subscribe((res) => {
      this.isRequestLoading = false;

      this.getData(this.user._id);
    });
  }

  async changeTeacherStatus(){
    try{
      swal.fire({
        title: 'Please select status',
        input: 'select',
        inputOptions: {
          1: 'Bronze',
          2: 'Silver',
          3: 'Gold'
        },
        inputPlaceholder: 'Select a status',
        showCancelButton: true,
        inputValidator: (value) => value ? '' : 'Please select something.'
      }).then(async ({value}) => {
        if(value){
          this.data.updateAdminUser(this.user._id, {
            status: parseInt(value)
          }).subscribe((res) => {
            if(res){
              this.getData(this.user._id);
            }
          })
        }
      })

    }catch(e){
      this.toastr.error(e.message);
    }
  }
}
